export const PROFILE_CHANGE_PASSWORD_FETCH = 'profile/CHANGE_PASSWORD_FETCH';
export const PROFILE_CHANGE_PASSWORD_DATA = 'profile/CHANGE_PASSWORD_DATA';
export const PROFILE_CHANGE_PASSWORD_ERROR = 'profile/CHANGE_PASSWORD_ERROR';

export const PROFILE_USER_FETCH = 'profile/GET_USER_FETCH';
export const PROFILE_USER_DATA = 'profile/GET_USER_DATA';
export const PROFILE_USER_ERROR = 'profile/GET_USER_ERROR';
export const PROFILE_USER_ACTIVITY = 'profile/GET_USER_ACTIVITY';
export const PROFILE_RESET_USER = 'profile/RESET_USER';

export const PROFILE_CHANGE_USER_LEVEL = 'profile/CHANGE_USER_LEVEL';

export const PROFILE_CHANGE_USER_FETCH = 'profile/CHANGE_USER_FETCH';
export const PROFILE_CHANGE_USER_DATA = 'profile/CHANGE_USER_DATA';
export const PROFILE_CHANGE_USER_ERROR = 'profile/CHANGE_USER_ERROR';

